import { PROJECT_CACHE_V2 } from "constants/serviceWorker";
import { getIndexedDb } from "utils/indexedDb";
import { ICacheStorage, ICacheStorageState } from "../types";

class CacheStorage implements ICacheStorage {
  constructor(protected readonly id: string) {}

  async get(): Promise<any> {
    const indexedDb = await getIndexedDb();

    return indexedDb?.get(this.id, PROJECT_CACHE_V2);
  }

  async save(state: ICacheStorageState): Promise<void> {
    const indexDb = await getIndexedDb();
    await indexDb?.put(this.id, state, PROJECT_CACHE_V2);
  }

  public static async getAll() {
    const indexedDb = await getIndexedDb();

    return indexedDb?.getAll(PROJECT_CACHE_V2);
  }
}

export default CacheStorage;
